import { render, staticRenderFns } from "./Inscricoes.vue?vue&type=template&id=63894307&"
import script from "./Inscricoes.vue?vue&type=script&lang=js&"
export * from "./Inscricoes.vue?vue&type=script&lang=js&"
import style0 from "./Inscricoes.vue?vue&type=style&index=0&id=63894307&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports